import { useTenantTheme } from './use-tenant-theme';
import { getTenantCurrencyCookie } from '@/services';

export const DEFAULT_TENANT_CURRENCY = 'USD';

export const useTenantCurrency = () => {
  const { tenant } = useTenantTheme();
  return (
    tenant?.currency ||
    getTenantCurrencyCookie() ||
    DEFAULT_TENANT_CURRENCY
  ).toUpperCase();
};
